import React, { ReactNode } from "react";
import { Box, SystemProps } from "flicket-ui";
import { useRouter } from "next/router";

import { DesktopMenu } from "~components/common/Menu/menu.Desktop";
import { MobileMenu } from "~components/common/Menu/menu.Mobile";
import { useAccount } from "~hooks/useAccount";
import { useIsMobile } from "~hooks/useIsMobile";

interface MenuProps extends SystemProps {
  name?: string;
  loggedIn?: boolean;
  children?: ReactNode;
}

export const Menu = ({ children, ...props }: MenuProps) => {
  const isMobile = useIsMobile();
  const router = useRouter();
  const { user, hasLoaded, isLoggedIn, logout } = useAccount();

  return (
    <Box width="100%" {...props} position="fixed" top={0} zIndex="sticky">
      {isMobile ? (
        <MobileMenu
          isLoggedIn={isLoggedIn}
          pathname={router?.pathname}
          logout={logout}
        >
          {children}
        </MobileMenu>
      ) : (
        <DesktopMenu
          pathname={router?.pathname}
          firstName={user?.firstName}
          lastName={user?.lastName}
          loggedIn={isLoggedIn}
          checkingSession={!hasLoaded}
        />
      )}
    </Box>
  );
};

export default Menu;
